import { useMemo } from 'react';
import { Field, Dropdown } from '@carboledger/ui';
import { useTranslations } from '@/hooks';
import { buildRetireCreditsOptions } from './fulfill.constants';

// Optional — Section 3 decides what to fulfill from regardless of the answer.
export const RetireCreditsField = () => {
  const t = useTranslations();
  const options = useMemo(() => buildRetireCreditsOptions(t), [t]);

  return (
    <Field name="retireCredits">
      {({ id, name, value, onChange, onBlur, status, message }) => (
        <Dropdown
          id={id}
          name={name}
          label={t('FIELD_RETIRE_CREDITS')}
          placeholder={t('FORM_SELECT_RETIRE_CREDITS')}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          status={status}
          message={message}
          options={options}
        />
      )}
    </Field>
  );
};
